import { ref, Ref } from "vue";
import RepositoryAgents from "@/repositories/agents-repository/RepositoryAgents";
import ModelAgent from "@models/agents/ModelAgent";

export default class ServiceAgents {
	private static _instance: ServiceAgents | null = null;
	private readonly _repositoryAgents: RepositoryAgents;
	private readonly _agents: Ref<ModelAgent[]>;
	private readonly _selectedPurchaseAgent: Ref<ModelAgent | null>;

	constructor() {
		this._agents = ref([]);
		this._selectedPurchaseAgent = ref(null);
		this._repositoryAgents = new RepositoryAgents();
	}

	public static of() {
		if (ServiceAgents._instance === null) {
			ServiceAgents._instance = new ServiceAgents();
		}

		return ServiceAgents._instance;
	}

	public get agents(): Ref<ModelAgent[]> {
		return this._agents;
	}

	public set agents(value: ModelAgent[]) {
		this._agents.value = value;
	}

	public get selectedPurchaseAgent(): Ref<ModelAgent | null> {
		return this._selectedPurchaseAgent;
	}

	public set selectedPurchaseAgent(value: ModelAgent | null) {
		this._selectedPurchaseAgent.value = value;
	}

	public async fetchAgentsAvailableForPurchase(paymentMethod?: 'bank_card' | 'phone') {
		this.agents.value = await this._repositoryAgents.fetchAgentsAvailableForPurchase(paymentMethod);
	}
}
